import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Frame } from '../components/shell/AppShell';
import PageHeader from '../components/shell/PageHeader';
import AccountSections from '../components/more/AccountSections';
import { moreFor } from '../lib/navigation';
import roomArt from '../assets/bg/member-room.webp';

/**
 * More, for a member: everything that is not a primary destination, grouped
 * as the 2.0 More blueprint asks. Staff have their own More at /admin/more,
 * with administration above the same personal groups, and are sent there.
 */
const Settings = () => {
  const { user } = useAuth();
  if (moreFor(user) !== '/settings') return <Navigate to={moreFor(user)} replace />;

  return (
    <Frame user={user} background={roomArt} activeKey="more">
      <div data-testid="settings-page">
        <PageHeader title="More" subtitle="Account · Security · Membership" />
        <div className="max-w-lg mx-auto px-4 pb-6 pt-2 space-y-5">
          <AccountSections />
        </div>
      </div>
    </Frame>
  );
};

export default Settings;
